"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.groups.selectNumber': '电话号码',
    'whatsapp.groups.selectNumberPlaceholder': '选择电话号码...',
    'whatsapp.groups.loadFailed': '无法加载 WhatsApp 群组。',
    'whatsapp.groups.noGroups': '未找到群组。',
    'whatsapp.groups.trackingOn': '追踪中',
    'whatsapp.groups.trackingOff': '未追踪',
    'whatsapp.groups.loading': '加载中...',
    'whatsapp.groups.notFound': '未找到群组。',
    'whatsapp.groups.info': '群组信息',
    'whatsapp.groups.name': '名称',
    'whatsapp.groups.waId': 'WhatsApp ID',
    'whatsapp.groups.phone': '电话号码',
    'whatsapp.groups.tracking': '启用消息追踪',
    'whatsapp.groups.pinMessage.label': '置顶消息',
    'whatsapp.groups.pinMessage.placeholder': '要在群组中置顶的消息内容...',
    'whatsapp.groups.pinMessage.hint': '启用跟踪且机器人是管理员时，此消息将被置顶。',
    'whatsapp.groups.pinReminder.label': '重新发送置顶消息',
    'whatsapp.groups.pinReminder.intervalLabel': '间隔（小时）',
    'whatsapp.groups.pinReminder.hint': '自上次提醒以来收到至少10条新消息时，将重新发送置顶消息。',
    'whatsapp.groups.tracking.badge': '追踪中',
    'whatsapp.groups.communicationType.wa': 'WA',
    'whatsapp.groups.communicationType.tele': 'TELE',
    'whatsapp.groups.teleId': 'Telegram ID',
    'whatsapp.groups.trackingEnabled': '消息追踪已启用。',
    'whatsapp.groups.trackingDisabled': '消息追踪已禁用。',
    'whatsapp.groups.trackingFailed': '无法更新追踪设置。',
    'whatsapp.groups.messages': '已追踪消息',
    'whatsapp.groups.noMessages': '暂无已追踪消息。',
    'whatsapp.groups.openGroup': '打开群组',
    'whatsapp.groups.back': '返回',
    'whatsapp.groups.copyUrl.label': '复制公开链接',
    'whatsapp.groups.copyUrl.copied': '已复制！',
    'whatsapp.groups.copyUrl.title': '复制此群组的公开链接（可选电话号码过滤）',
    'whatsapp.groups.copyUrl.success': '公开链接已复制到剪贴板。',
    'whatsapp.groups.copyUrl.failed': '无法复制公开链接。',
    'whatsapp.groups.botSettings': '机器人设置',
    'whatsapp.groups.avatar': '头像',
    'whatsapp.groups.selectAvatar': '-- 选择头像 --',
    'whatsapp.groups.botInstruction': '机器人指令',
    'whatsapp.groups.botInstructionPlaceholder': '输入 WhatsApp 机器人指令...',
    'whatsapp.groups.saveSettings': '保存设置',
    'whatsapp.groups.settingsSaved': '设置保存成功。',
    'whatsapp.groups.settingsFailed': '无法保存设置。',
    'whatsapp.groups.listTitle': 'WhatsApp 群组',
    'whatsapp.groups.addGroup': '添加群组',
    'whatsapp.groups.announce.label': '所有用户可以在群中发言',
    'whatsapp.groups.announce.hint': '启用后，所有群成员都可以发送消息（不仅仅是管理员）。',
    'whatsapp.groups.announce.saved': '公告模式已更新。',
    'whatsapp.groups.announce.failed': '更新公告模式失败。',
    'whatsapp.groups.remoteAccess.label': '远程访问',
    'whatsapp.groups.accessPassword.label': '访问密码',
    'whatsapp.groups.security.save': '设置安全',
    'whatsapp.groups.security.saved': '安全设置已保存。',
    'whatsapp.groups.security.failed': '保存安全设置失败。',
    'whatsapp.groups.gate.title': '群组访问',
    'whatsapp.groups.gate.password': '密码',
    'whatsapp.groups.gate.submit': '进入',
    'whatsapp.groups.gate.error': '密码无效，请重试。',
    'whatsapp.groups.gate.notAllowed': '此群组不适用于所选电话号码。',
    'whatsapp.groups.dateFrom': '从',
    'whatsapp.groups.dateTo': '到',
    'whatsapp.groups.summarize': '生成摘要',
    'whatsapp.groups.summary': '摘要',
    'whatsapp.groups.summaries.title': '摘要列表',
    'whatsapp.groups.summaries.empty': '暂无摘要。',
    'whatsapp.groups.summaries.date': '日期',
    'whatsapp.groups.summaries.view': '查看',
    'whatsapp.groups.summaries.excerpt': '摘要',
    'whatsapp.groups.summaries.modalTitle': '摘要详情',
    'whatsapp.groups.summarizeDone': '摘要生成成功。',
    'whatsapp.groups.summarizeFailed': '生成摘要失败。',
    'whatsapp.groups.syncMessages.button': '同步消息',
    'whatsapp.groups.syncMessages.done': '消息同步成功。',
    'whatsapp.groups.sendMessage.title': '发送消息',
    'whatsapp.groups.sendMessage.placeholder': '输入要发送到群组的消息...',
    'whatsapp.groups.sendMessage.send': '发送',
    'whatsapp.groups.sendMessage.success': '消息已发送。',
    'whatsapp.groups.sendMessage.failed': '消息发送失败。',
    'whatsapp.groups.trackingDisabledHint': '该群组的跟踪已禁用。启用跟踪以查看消息、发送消息和查看摘要。',
    'whatsapp.groups.syncMessages.failed': '消息同步失败。',
    'whatsapp.groups.media.download': '下载',
    'whatsapp.groups.media.downloading': '下载中...',
    'whatsapp.groups.media.downloadFailed': '媒体下载失败。',
    'whatsapp.groups.media.attachment': '附件',
    'whatsapp.groups.agentChecking': '正在检查 WhatsApp 代理状态...',
    'whatsapp.groups.agentOffline': 'WhatsApp 代理已离线。所有需要代理连接的操作已被禁用。',
    'whatsapp.groups.loading_groups': '正在加载群组...',
    'whatsapp.groups.members.title': '群成员',
    'whatsapp.groups.members.sync': '同步',
    'whatsapp.groups.members.syncFailed': '同步成员失败。',
    'whatsapp.groups.members.empty': '未找到成员。点击同步从 WhatsApp 加载。',
    'whatsapp.groups.members.phone': '电话',
    'whatsapp.groups.members.username': '用户名',
    'whatsapp.groups.members.id': 'WA ID',
    'whatsapp.groups.members.name': '名称',
    'whatsapp.groups.members.role': '角色',
    'whatsapp.groups.members.superAdmin': '超级管理员',
    'whatsapp.groups.members.admin': '管理员',
    'whatsapp.groups.members.member': '成员',
    'whatsapp.groups.members.promote': '提升为管理员',
    'whatsapp.groups.members.promoted': '成员已提升为管理员。',
    'whatsapp.groups.members.promoteFailed': '提升成员失败。',
    'whatsapp.groups.addParticipants.title': '添加参与者',
    'whatsapp.groups.addParticipants.phonePlaceholder': '输入电话号码...',
    'whatsapp.groups.addParticipants.addPhone': '添加号码',
    'whatsapp.groups.addParticipants.noPhonesYet': '尚未添加电话号码。',
    'whatsapp.groups.addParticipants.submit': '添加参与者',
    'whatsapp.groups.addParticipants.success': '参与者添加成功。',
    'whatsapp.groups.addParticipants.failed': '添加参与者失败。',
    'whatsapp.groups.members.remove': '移除',
    'whatsapp.groups.members.removed': '成员已从群组中移除。',
    'whatsapp.groups.members.removeFailed': '移除成员失败。',
    'whatsapp.groups.members.feedBotData': '提供机器人数据',
    'whatsapp.groups.members.allowBotUsage': '允许使用机器人',
    'whatsapp.groups.members.updateFailed': '更新成员设置失败。',
    'whatsapp.groups.joinGroup': '加入群组',
    'whatsapp.groups.joinLink.modalTitle': '加入 WhatsApp 群组',
    'whatsapp.groups.joinLink.hint': '粘贴 WhatsApp 群组邀请链接（如 https://chat.whatsapp.com/...），代理将加入该群组。',
    'whatsapp.groups.joinLink.label': '邀请链接',
    'whatsapp.groups.joinLink.placeholder': 'https://chat.whatsapp.com/...',
    'whatsapp.groups.joinLink.required': '请输入邀请链接。',
    'whatsapp.groups.joinLink.submit': '加入',
    'whatsapp.groups.joinLink.cancel': '取消',
    'whatsapp.groups.joinLink.success': '成功加入群组。',
    'whatsapp.groups.joinLink.failed': '加入群组失败。',
    'whatsapp.groups.trackLogs': '活动日志',
    'whatsapp.groups.trackLogs.noLogs': '暂无活动日志。',
    'whatsapp.groups.trackLogs.logType.neutral': '中性',
    'whatsapp.groups.trackLogs.logType.good': '良好',
    'whatsapp.groups.trackLogs.logType.warning': '警告',
    'whatsapp.groups.trackLogs.logType.critical': '严重',
};
